import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2385a2e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-subitem"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bullet"
}, "·", -1));
const _hoisted_3 = ["textContent"];
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: "text",
        textContent: _toDisplayString(__props.content)
      }, null, 8, _hoisted_3)]);
    };
  }
};